import { render, staticRenderFns } from "./BaseExpander.vue?vue&type=template&id=1892e64c&scoped=true"
import script from "./BaseExpander.vue?vue&type=script&lang=js"
export * from "./BaseExpander.vue?vue&type=script&lang=js"
import style0 from "./BaseExpander.vue?vue&type=style&index=0&id=1892e64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892e64c",
  null
  
)

export default component.exports